export const uaeStatesAr = {
  'ae-az': 'أبوظبي',
  'ae-du': 'دبي',
  'ae-sh': 'الشارقة',
  'ae-rk': 'رأس الخيمة',
  'ae-uq': 'ام القيوين',
  'ae-fu': 'الفجيرة',
  'ae-740': '',
  'ae-aj': 'عجمان',
  'ae-742': '',
}

export const countryNamesAr =
{
  'ca': 'كندا',
  'cn': 'الصين',
  'cr': 'كوستاريكا',
  'eg': 'مصر',
  'in': 'الهند',
  'ru': 'روسيا',
  'ae': 'الإمارات العربية المتحدة',
  'us': 'الولايات المتحدة',
  'se': 'السويد',
  'es': 'إسبانيا',
  'de': 'ألمانيا',
  'jp': 'اليابان',
  'fr': 'فرنسا',
  'uk': 'المملكة المتحدة',
  'br': 'البرازيل',
  'mx': 'المكسيك',
  'au': 'أستراليا',
  'it': 'إيطاليا',
  'za': 'جنوب إفريقيا',
  'kr': 'كوريا الجنوبية',
  'ar': 'الأرجنتين',
  'sa': 'السعودية',
  'pk': 'باكستان',
  'ng': 'نيجيريا',
  'bd': 'بنغلاديش',
  'tr': 'تركيا',
  'ir': 'إيران',
  'ph': 'الفلبين',
  'vn': 'فيتنام',
  'et': 'إثيوبيا',
  'cd': 'جمهورية الكونغو الديمقراطية',
  'tz': 'تنزانيا',
  'th': 'تايلاند',
  'mm': 'ميانمار',
  'sd': 'السودان',
  'ug': 'أوغندا',
  'dz': 'الجزائر',
  'ua': 'أوكرانيا',
  'iq': 'العراق',
  'af': 'أفغانستان',
  'pl': 'بولندا',
  'ma': 'المغرب',
  'uz': 'أوزبكستان',
  'pe': 'بيرو',
  'ao': 'أنغولا',
  'my': 'ماليزيا',
  'mz': 'موزمبيق',
  'gh': 'غانا',
  'np': 'نيبال',
  've': 'فنزويلا',
  'ye': 'اليمن',
  'cm': 'الكاميرون',
  'ci': 'ساحل العاج',
  'kp': 'كوريا الشمالية',
  'ne': 'نيجيريا',
  'tw': 'تايوان',
  'lk': 'سريلانكا',
  'kz': 'كازاخستان',
  'ml': 'مالي',
  'ro': 'رومانيا',
  'zm': 'زامبيا',
  'gp': 'غوادلوب',
  'cu': 'كوبا',
  'be': 'بلجيكا',
  'gr': 'اليونان',
  'tn': 'تونس',
  'ch': 'سويسرا',
  'jo': 'الأردن',
  'sk': 'سلوفاكيا',
  'lb': 'لبنان',
  'af1': 'إفريقيا',
  'cz': 'جمهورية التشيك',
  'rs': 'صربيا',
  'pa': 'بنما',
  'pt': 'البرتغال',
  'si': 'سلوفينيا',
  'hr': 'كرواتيا',
  'ba': 'البوسنة والهرسك',
  'bg': 'بلغاريا',
  'al': 'ألبانيا',
  'lt': 'ليتوانيا',
  'bw': 'بوتسوانا',
  'qa': 'قطر',
  'lv': 'لاتفيا',
  'py': 'باراغواي',
  'na': 'ناميبيا',
  'mk': 'مقدونيا',
  'sv': 'السلفادور',
  'ke': 'كينيا',
  'gt': 'غواتيمالا',
  'lu': 'لوكسمبورغ',
  'me': 'الجبل الأسود',
  'bs': 'باهاماس',
  'ie': 'أيرلندا',
  'mt': 'مالطا',
  'bb': 'باربادوس',
  'is': 'آيسلندا',
  'gf': 'غويانا الفرنسية',
  'gy': 'غيانا',
  'sr': 'سورينام',
  'mq': 'مارتينيك',
  're': 'لا ريونيون',
  'ss': 'جنوب السودان',
  'cv': 'الرأس الأخضر',
  'pf': 'بولينزيا الفرنسية',
  'tm': 'تركمانستان',
  'nc': 'كاليدونيا الجديدة',
  'gi': 'جبل طارق',
  'bn': 'بروناي',
  'mo': 'ماكاو',
  'tt': 'ترينيداد وتوباغو',
  'fj': 'فيجي',
  'ky': 'جزر كايمان',
  'gd': 'غرينادا',
  'lc': 'سانت لوسيا',
  'nz': 'نيوزيلندا',
  'vc': 'سانت فينسنت وجزر غرناطة',
  'tl': 'تيمور الشرقية',
  'dm': 'جمهورية الدومينيكان',
  'kn': 'سانت كيتس ونيفيس',
  'ms': 'مونتسرات',
  'ai': 'أنغويلا',
  'tc': 'جزر توركس وكايكوس',
  'vg': 'جزر العذراء البريطانية',
  'bm': 'برمودا',
  'aw': 'أروبا',
  'ad': 'أندورا',
  'sc': 'سيشل',
  'ag': 'أنتيغوا وباربودا',
  'im': 'جزيرة مان',
  'gg': 'غيرنزي',
  'yt': 'مايوت',
  'je': 'جيرزي',
  'gu': 'غوام',
  'mp': 'جزر ماريانا الشمالية',
  'pr': 'بورتوريكو',
  'vi': 'جزر العذراء الأمريكية',
  'as': 'ساموا الأمريكية',
  'fo': 'جزر فارو',
  'hk': 'هونغ كونغ',
  'gl': 'جرينلاند',
  'pg': 'بابوا غينيا الجديدة',
  'nr': 'ناورو',
  'sj': 'سفالبارد ويان ماين',
  'hm': 'جزيرة هيرد وجزر ماكدونالد',
  'nf': 'جزيرة نورفولك',
  'cx': 'جزيرة كريسماس',
  'cc': 'جزر كوكوس (كيلينغ)',
  'pw': 'بالاو',
  'ck': 'جزر كوك',
  'mh': 'جزر مارشال',
  'tv': 'توفالو',
  'wf': 'والس وفوتونا',
  'fk': 'جزر فوكلاند (مالفيناس)',
  'nu': 'نيوي',
  'st': 'ساو تومي وبرينسيبي',
  'ki': 'كيريباتي',
  'to': 'تونغا',
  'fm': 'ميكرونيزيا',
  'km': 'جزر القمر',
  'io': 'إقليم المحيط الهندي البريطاني',
  'vu': 'فانواتو',
  'ws': 'ساموا',
  'sh': 'سانت هيلينا',
  'cg': 'جمهورية الكونغو',
  'eh': 'الصحراء الغربية',
  'gq': 'غينيا الاستوائية',
  'sz': 'سوازيلاند',
  'dj': 'جيبوتي',
  'mv': 'المالديف',
  'ls': 'ليسوتو',
  'li': 'ليختنشتاين',
  'mc': 'مناكو',
  'sm': 'سان مارينو',
  'va': 'الكرسي الرسولي',
  'tf': 'الأراضي الجنوبية الفرنسية والأنتارتيكية',
  'aq': 'القارة القطبية الجنوبية',
  'gs': 'جورجيا الجنوبية وجزر ساندويتش الجنوبية',
  'cw': 'كوراساو',
  'bh': 'البحرين',
  'kw': 'الكويت',
  'om': 'سلطنة عمان',
  'cv1': 'الرأس الأخضر',
  'gm': 'غامبيا',
  'bq': 'جزر بونير, سينت يوستاتيوس وسابا الهولندية',
  'bl': 'سانت بارتيلمي',
  'mf': 'سانت مارتن',
  'pn': 'جزر بيتكيرن',
  'sx': 'سانت مارتن (هولندا)',
  'pm': 'سان بيير وميكلون'
}

export const countryNamesEn = {
  'CANADA': 'ca',
  'CHINA': 'cn',
  'COSTA RICA': 'cr',
  'EGYPT': 'eg',
  'INDIA': 'in',
  'RUSSIA': 'ru',
  'UNITED ARAB EMIRATES': 'ae',
  'United States': 'us',
  'SWEDEN': 'se',
  'SPAIN': 'es',
  'GERMANY': 'de',
  'JAPAN': 'jp',
  'FRANCE': 'fr',
  'UNITED KINGDOM': 'uk',
  'BRAZIL': 'br',
  'MEXICO': 'mx',
  'AUSTRALIA': 'au',
  'ITALY': 'it',
  'SOUTH AFRICA': 'za',
  'SOUTH KOREA': 'kr',
  'ARGENTINA': 'ar',
  'SAUDI ARABIA': 'sa',
  'PAKISTAN': 'pk',
  'NIGERIA': 'ng',
  'BANGLADESH': 'bd',
  'TURKEY': 'tr',
  'IRAN': 'ir',
  'PHILIPPINES': 'ph',
  'VIETNAM': 'vn',
  'ETHIOPIA': 'et',
  'DR CONGO': 'cd',
  'TANZANIA': 'tz',
  'THAILAND': 'th',
  'MYANMAR': 'mm',
  'SUDAN': 'sd',
  'UGANDA': 'ug',
  'ALGERIA': 'dz',
  'UKRAINE': 'ua',
  'IRAQ': 'iq',
  'AFGHANISTAN': 'af',
  'POLAND': 'pl',
  'MOROCCO': 'ma',
  'UZBEKISTAN': 'uz',
  'PERU': 'pe',
  'ANGOLA': 'ao',
  'MALAYSIA': 'my',
  'MOZAMBIQUE': 'mz',
  'GHANA': 'gh',
  'NEPAL': 'np',
  'VENEZUELA': 've',
  'YEMEN': 'ye',
  'CAMEROON': 'cm',
  'COTE D\'IVOIRE': 'ci',
  'NORTH KOREA': 'kp',
  'NIGER': 'ne',
  'TAIWAN': 'tw',
  'SRI LANKA': 'lk',
  'KAZAKHSTAN': 'kz',
  'MALI': 'ml',
  'ROMANIA': 'ro',
  'ZAMBIA': 'zm',
  'GUADELOUPE': 'gp',
  'CUBA': 'cu',
  'BELGIUM': 'be',
  'GREECE': 'gr',
  'TUNISIA': 'tn',
  'SWITZERLAND': 'ch',
  'JORDAN': 'jo',
  'SLOVAKIA': 'sk',
  'LEBANON': 'lb',
  'AFRICA': 'af',
  'CZECH REPUBLIC': 'cz',
  'SERBIA': 'rs',
  'PANAMA': 'pa',
  'PORTUGAL': 'pt',
  'SLOVENIA': 'si',
  'CROATIA': 'hr',
  'BOSNIA AND HERZEGOVINA': 'ba',
  'BULGARIA': 'bg',
  'ALBANIA': 'al',
  'LITHUANIA': 'lt',
  'BOTSWANA': 'bw',
  'QATAR': 'qa',
  'LATVIA': 'lv',
  'PARAGUAY': 'py',
  'NAMIBIA': 'na',
  'MACEDONIA': 'mk',
  'ELSALVADOR': 'sv',
  'KENYA': 'ke',
  'GUATEMALA': 'gt',
  'LUXEMBOURG': 'lu',
  'MONTENEGRO': 'me',
  'BAHAMAS': 'bs',
  'IRELAND': 'ie',
  'MALTA': 'mt',
  'BARBADOS': 'bb',
  'ICELAND': 'is',
  'FRENCH GUIANA': 'gf',
  'GUYANA': 'gy',
  'SURINAME': 'sr',
  'MARTINIQUE': 'mq',
  'REUNION': 're',
  'SOUTH SUDAN': 'ss',
  'CAPE VERDE': 'cv',
  'FRENCH POLYNESIA': 'pf',
  'TURKMENISTAN': 'tm',
  'NEW CALEDONIA': 'nc',
  'GIBRALTAR': 'gi',
  'BRUNEI': 'bn',
  'MACAU': 'mo',
  'TRINIDAD AND TOBAGO': 'tt',
  'FIJI': 'fj',
  'CAYMAN ISLANDS': 'ky',
  'GRENADA': 'gd',
  'SAINT LUCIA': 'lc',
  'NEW ZEALAND': 'nz',
  'ST VINCENT AND THE GRENADINES': 'vc',
  'TIMOR-LESTE': 'tl',
  'DOMINICA': 'dm',
  'SAINT KITTS AND NEVIS': 'kn',
  'MONTSERRAT': 'ms',
  'ANGUILLA': 'ai',
  'TURKS AND CAICOS ISLANDS': 'tc',
  'BRITISH VIRGIN ISLANDS': 'vg',
  'BERMUDA': 'bm',
  'ARUBA': 'aw',
  'ANDORRA': 'ad',
  'SEYCHELLES': 'sc',
  'ANTIGUA AND BARBUDA': 'ag',
  'ISLE OF MAN': 'im',
  'GUERNSEY': 'gg',
  'MAYOTTE': 'yt',
  'JERSEY': 'je',
  'GUAM': 'gu',
  'NORTHERN MARIANA ISLANDS': 'mp',
  'PUERTO RICO': 'pr',
  'US VIRGIN ISLANDS': 'vi',
  'AMERICAN SAMOA': 'as',
  'FAROE ISLANDS': 'fo',
  'HONG KONG': 'hk',
  'GREENLAND': 'gl',
  'PAPUA NEW GUINEA': 'pg',
  'NAURU': 'nr',
  'SVALBARD AND JAN MAYEN': 'sj',
  'HEARD ISLAND AND MCDONALD ISLANDS': 'hm',
  'NORFOLK ISLAND': 'nf',
  'CHRISTMAS ISLAND': 'cx',
  'COCOS (KEELING) ISLANDS': 'cc',
  'PALAU': 'pw',
  'COOK ISLANDS': 'ck',
  'MARSHALL ISLANDS': 'mh',
  'TUVALU': 'tv',
  'WALLIS AND FUTUNA': 'wf',
  'FALKLAND ISLANDS': 'fk',
  'NIUE': 'nu',
  'SAO TOME AND PRINCIPE': 'st',
  'KIRIBATI': 'ki',
  'TONGA': 'to',
  'MICRONESIA': 'fm',
  'COMOROS': 'km',
  'BRITISH INDIAN OCEAN TERRITORY': 'io',
  'VANUATU': 'vu',
  'SAMOA': 'ws',
  'SAINT HELENA': 'sh',
  'REPUBLIC OF THE CONGO': 'cg',
  'DEMOCRATIC REPUBLIC OF CONGO': 'cd',
  'WESTERN SAHARA': 'eh',
  'EQUATORIAL GUINEA': 'gq',
  'SWAZILAND': 'sz',
  'DJIBOUTI': 'dj',
  'MALDIVES': 'mv',
  'LESOTHO': 'ls',
  'LIECHTENSTEIN': 'li',
  'MONACO': 'mc',
  'SAN MARINO': 'sm',
  'HOLY SEE': 'va',
  'FRENCH SOUTHERN AND ANTARCTIC LANDS': 'tf',
  'ANTARCTICA': 'aq',
  'SOUTH GEORGIA AND THE SOUTH SANDWICH ISLANDS': 'gs',
  'CURACAO': 'cw',
  'BAHRAIN': 'bh',
  'KUWAIT': 'kw',
  'OMAN': 'om',
  'CABO VERDE': 'cv',
  'GAMBIA': 'gm',
  'BONAIRE, SINT EUSTATIUS AND SABA': 'bq',
  'ST BARTHELEMY': 'bl',
  'ST MARTIN': 'mf',
  'CARIBBEAN NETHERLANDS': 'bq',
  'FRENCH SOUTHERN TERRITORIES': 'tf',
  'PITCAIRN ISLANDS': 'pn',
  'SINT MAARTEN': 'sx',
  'SAINT PIERRE AND MIQUELON': 'pm',
}

export enum Countries {
  Afghanistan = "af",
  Albania = "al",
  Algeria = "dz",
  AmericanSamoa = "as",
  Andorra = "ad",
  Angola = "ao",
  Anguilla = "ai",
  AntiguaandBarbuda = "ag",
  Argentina = "ar",
  Armenia = "am",
  Aruba = "aw",
  Australia = "au",
  Austria = "at",
  Azerbaijan = "az",
  Bahamas = "bs",
  Bahrain = "bh",
  Bangladesh = "bd",
  Barbados = "bb",
  Belarus = "by",
  Belgium = "be",
  Belize = "bz",
  Benin = "bj",
  Bermuda = "bm",
  Bhutan = "bt",
  Bolivia = "bo",
  BosniaandHerzegovina = "ba",
  Botswana = "bw",
  Brazil = "br",
  BritishIndianOceanTerritory = "io",
  BritishVirginIslands = "vg",
  Brunei = "bn",
  Bulgaria = "bg",
  BurkinaFaso = "bf",
  Burundi = "bi",
  Cambodia = "kh",
  Cameroon = "cm",
  Canada = "ca",
  CapeVerde = "cv",
  CaribbeanNetherlands = "bq",
  CaymanIslands = "ky",
  CentralAfricanRepublic = "cf",
  Chad = "td",
  Chile = "cl",
  China = "cn",
  ChristmasIsland = "cx",
  CocosIslands = "cc",
  Colombia = "co",
  Comoros = "km",
  DemocraticRepublicoftheCongo = "cd",
  RepublicoftheCongo = "cg",
  CookIslands = "ck",
  CostaRica = "cr",
  IvoryCoast = "ci",
  Croatia = "hr",
  Cuba = "cu",
  Curacao = "cw",
  Cyprus = "cy",
  CzechRepublic = "cz",
  Denmark = "dk",
  Djibouti = "dj",
  Dominica = "dm",
  DominicanRepublic = "do",
  Ecuador = "ec",
  Egypt = "eg",
  ElSalvador = "sv",
  EquatorialGuinea = "gq",
  Eritrea = "er",
  Estonia = "ee",
  Ethiopia = "et",
  FalklandIslands = "fk",
  FaroeIslands = "fo",
  Fiji = "fj",
  Finland = "fi",
  France = "fr",
  FrenchGuiana = "gf",
  FrenchPolynesia = "pf",
  Gabon = "ga",
  Gambia = "gm",
  Georgia = "ge",
  Germany = "de",
  Ghana = "gh",
  Gibraltar = "gi",
  Greece = "gr",
  Greenland = "gl",
  Grenada = "gd",
  Guadeloupe = "gp",
  Guam = "gu",
  Guatemala = "gt",
  Guernsey = "gg",
  Guinea = "gn",
  GuineaBissau = "gw",
  Guyana = "gy",
  Haiti = "ht",
  Honduras = "hn",
  HongKong = "hk",
  Hungary = "hu",
  Iceland = "is",
  India = "in",
  Indonesia = "id",
  Iran = "ir",
  Iraq = "iq",
  Ireland = "ie",
  IsleofMan = "im",
  Israel = "il",
  Italy = "it",
  Jamaica = "jm",
  Japan = "jp",
  Jersey = "je",
  Jordan = "jo",
  Kazakhstan = "kz",
  Kenya = "ke",
  Kiribati = "ki",
  Kosovo = "xk",
  Kuwait = "kw",
  Kyrgyzstan = "kg",
  Laos = "la",
  Latvia = "lv",
  Lebanon = "lb",
  Lesotho = "ls",
  Liberia = "lr",
  Libya = "ly",
  Liechtenstein = "li",
  Lithuania = "lt",
  Luxembourg = "lu",
  Macau = "mo",
  Macedonia = "mk",
  Madagascar = "mg",
  Malawi = "mw",
  Malaysia = "my",
  Maldives = "mv",
  Mali = "ml",
  Malta = "mt",
  MarshallIslands = "mh",
  Martinique = "mq",
  Mauritania = "mr",
  Mauritius = "mu",
  Mayotte = "yt",
  Mexico = "mx",
  Micronesia = "fm",
  Moldova = "md",
  Monaco = "mc",
  Mongolia = "mn",
  Montenegro = "me",
  Montserrat = "ms",
  Morocco = "ma",
  Mozambique = "mz",
  Myanmar = "mm",
  Namibia = "na",
  Nauru = "nr",
  Nepal = "np",
  Netherlands = "nl",
  NewCaledonia = "nc",
  NewZealand = "nz",
  Nicaragua = "ni",
  Niger = "ne",
  Nigeria = "ng",
  Niue = "nu",
  NorfolkIsland = "nf",
  NorthKorea = "kp",
  NorthernMarianaIslands = "mp",
  Norway = "no",
  Oman = "om",
  Pakistan = "pk",
  Palau = "pw",
  Palestine = "ps",
  Panama = "pa",
  PapuaNewGuinea = "pg",
  Paraguay = "py",
  Peru = "pe",
  Philippines = "ph",
  Poland = "pl",
  Portugal = "pt",
  PuertoRico = "pr",
  Qatar = "qa",
  Reunion = "re",
  Romania = "ro",
  Russia = "ru",
  Rwanda = "rw",
  SaintBarthelemy = "bl",
  SaintHelena = "sh",
  SaintKittsandNevis = "kn",
  SaintLucia = "lc",
  SaintMartin = "mf",
  SaintPierreandMiquelon = "pm",
  SaintVincentandtheGrenadines = "vc",
  Samoa = "ws",
  SanMarino = "sm",
  SãoToméAndPríncipe = "st",
  SaudiArabia = "sa",
  Senegal = "sn",
  Serbia = "rs",
  Seychelles = "sc",
  SierraLeone = "sl",
  Singapore = "sg",
  SintMaarten = "sx",
  Slovakia = "sk",
  Slovenia = "si",
  SolomonIslands = "sb",
  Somalia = "so",
  SouthAfrica = "za",
  SouthKorea = "kr",
  SouthSudan = "ss",
  Spain = "es",
  SriLanka = "lk",
  Sudan = "sd",
  Suriname = "sr",
  SvalbardAndJanMayen = "sj",
  Swaziland = "sz",
  Sweden = "se",
  Switzerland = "ch",
  Syria = "sy",
  Taiwan = "tw",
  Tajikistan = "tj",
  Tanzania = "tz",
  Thailand = "th",
  TimorLeste = "tl",
  Togo = "tg",
  Tokelau = "tk",
  Tonga = "to",
  TrinidadandTobago = "tt",
  Tunisia = "tn",
  Turkey = "tr",
  Turkmenistan = "tm",
  TurksAndCaicosIslands = "tc",
  Tuvalu = "tv",
  USVirginIslands = "vi",
  Uganda = "ug",
  Ukraine = "ua",
  UnitedArabEmirates = "ae",
  UnitedKingdom = "gb",
  UnitedStates = "us",
  Uruguay = "uy",
  Uzbekistan = "uz",
  Vanuatu = "vu",
  Vatican = "va",
  Venezuela = "ve",
  Vietnam = "vn",
  WallisandFutuna = "wf",
  WesternSahara = "eh",
  Yemen = "ye",
  Zambia = "zm",
  Zimbabwe = "zw",
  ÅlandIslands = "ax"
}
//# sourceMappingURL=country-iso.enum.d.ts.map

export const Roles  = {
  cprUser:"Customer Profile And Registration",
  mktUser:"Marketing",
  adminUser:"admin",
  eService:'eservice',
  cmUser: "Case Management",
  apprvalBypass:"Bypass Marketing Approvals"
}
